import React, { useState, useEffect, useRef } from "react";
import { ChevronDownIcon } from "@radix-ui/react-icons";

export default function MultiSelect({
  options,
  selected,
  setSelected,
  placeholder,
}) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const dropdownRef = useRef(null);

  const toggleOption = (value) => {
    if (selected.includes(value)) {
      setSelected(selected.filter((v) => v !== value));
    } else {
      setSelected([...selected, value]);
    }
  };

  const filteredOptions = options.filter(
    (opt) =>
      typeof opt.label === "string" &&
      opt.label.toLowerCase().includes(search.toLowerCase()),
  );

  // Fermer si clic à l'extérieur
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative w-full" ref={dropdownRef}>
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="w-full border border-gray-300 rounded-md px-3 py-2 text-left text-sm flex justify-between items-center"
      >
        <span className="truncate">
          {selected.length > 0
            ? options
                .filter((o) => selected.includes(o.value))
                .map((o) => o.label)
                .join(", ")
            : placeholder || "Attribuer à un (ou plusieurs) utilisateur(s)"}
        </span>
        <ChevronDownIcon className="ml-2 h-4 w-4 text-gray-500" />
      </button>

      {open && (
        <div className="absolute z-10 mt-1 w-full mx-2  border bg-white shadow-lg max-h-60 overflow-auto">
          <input
            type="text"
            placeholder="Rechercher..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full border-b px-3 py-2 text-sm focus:outline-none"
          />
          {filteredOptions.map((option) => (
            <div
              key={option.value}
              className="flex items-center px-4 py-2 cursor-pointer hover:bg-gray-100"
              onClick={() => toggleOption(option.value)}
            >
              <input
                type="checkbox"
                checked={selected.includes(option.value)}
                readOnly
                className="mr-2"
              />
              {option.label}
            </div>
          ))}
          {filteredOptions.length === 0 && (
            <div className="px-4 py-2 text-sm text-gray-500">
              Aucun résultat
            </div>
          )}
        </div>
      )}
    </div>
  );
}
